import { z } from "zod/v4";

import { CreateExperienceAnalysisSchema } from "../dtos/experience-analysis";
import { CreateExperienceIntegrationDtoSchema } from "../dtos/experience-integrations";
import {
  ExperienceDto,
  ExperienceDtoSchema,
  ExperienceStatus,
} from "../dtos/experiences";
import { ExperienceListDto } from "../dtos/experiences-list";
import { S3FileLocationDtoSchema } from "../dtos/s3-file-location";
import { WidgetType } from "../dtos/widgets";

export const ViewModeList = ["view", "edit"] as const;
export type ViewMode = (typeof ViewModeList)[number];

export const ActionModeList = ["create", "edit"] as const;
export type ActionMode = (typeof ActionModeList)[number];

export const TabList = [
  "testGroups",
  "mods",
  "preview",
  "analytics",
  "targeting",
  "configure-analytics",
] as const;

export type TabType = (typeof TabList)[number];

export enum TabEnumFe {
  TEST_GROUPS = "testGroups",
  MODS = "mods",
  PREVIEW = "preview",
  ANALYTICS = "analytics",
  CONFIGURE_ANALYTICS = "configure-analytics",
  TARGETING = "targeting",
}

const ExperienceFrontendPropsSchema = z.object({
  viewMode: z.enum(ViewModeList),
  actionMode: z.enum(ActionModeList),
  step: z.number().default(0).optional(),
  tab: z.enum(TabList),
});

export const ExperienceFeSchema = z
  .object({
    ...ExperienceDtoSchema.shape,
    ...ExperienceFrontendPropsSchema.shape,
  })
  .extend({
    experienceAnalysis: CreateExperienceAnalysisSchema,
    id: z.uuid().optional(),
    productsLocation: S3FileLocationDtoSchema.nullish(),
    experienceIntegrations:
      CreateExperienceIntegrationDtoSchema.array().default([]),
    isNew: z.boolean().optional(),
    createdAtTs: z.number().optional(),
  })
  .omit({
    organizationId: true,
    lastUpdateTs: true,
    experienceKeyMetrics: true,
  });

export type ExperienceFe = z.infer<typeof ExperienceFeSchema>;

export type GenericExperienceFe =
  | ExperienceDto
  | ExperienceFe
  | ExperienceListDto;

export const PersonalizationStatusTextMap: Record<
  ExperienceStatus | "archived",
  string
> = {
  pending: "Inactive",
  paused: "Inactive",
  started: "Active",
  archived: "Archived",
  ended: "Inactive",
};

export const widgetTypeLabelMap: Record<WidgetType, string> = {
  messageBoxPopup: "Popup",
  discountProgressBar: "Progress Bar",
  messageBoxSlideOut: "Slideout",
  quantityButtons: "Quantity Buttons",
  shippingProgressBar: "Progress Bar",
  gwpVariantPicker: "GWP Variant Picker",
};
